module.exports = __webpack_public_path__ + "img/gh-30513-2.prt.4e47a069.jpg";